import { inject, Injectable, signal, computed } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { EventService, EventDto } from '@millionshow/api-client';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventStore {
  private readonly eventService = inject<EventService>(EventService);

  selectedEventId = signal<string | null>(null);
  isAdmin = signal<boolean>(false);

  private readonly $event = rxResource({
    stream: ({ params }) => {
      if (!params.eventId) {
        return of(null);
      }
      return this.eventService.eventControllerFindByIdV1({
        id: params.eventId,
      });
    },
    params: () => ({ eventId: this.selectedEventId() }),
  });

  selectedEvent = computed(() => {
    const eventData = this.$event.value() as EventDto | null;
    return eventData;
  });

  loading = computed(() => this.$event.isLoading());

  setEvent(eventId: string): void {
    this.selectedEventId.set(eventId);
  }

  clearEvent(): void {
    this.selectedEventId.set(null);
  }

  hasEvent(): boolean {
    return this.selectedEventId() !== null;
  }
}
